import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import AppContextProvider from "./context/app/provider";
import ProductContextProvider from "./context/product/provider";
import NotificationContextProvider from "./context/notification/provider";
import CategoryContextProvider from "./context/category/provider";
import AuthContextProvider from "./context/auth/provider";
import TrackingContextProvider from "./context/tracking-map/provider";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/localization/i18n";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
            <NotificationContextProvider>
                    <AuthContextProvider>
                            <AppContextProvider>
                              <I18nextProvider i18n={i18n}>
                                <App />
                              </I18nextProvider>
                            </AppContextProvider>
                    </AuthContextProvider>
            </NotificationContextProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
